import api, { adminApiPrefix } from './Api';
import {
  Offer,
  offerFromResponse,
  offerToUpsertRequest,
} from '../interfaces/Offer/Offer';

const offersAdminApiPrefix = `${adminApiPrefix}/offers`;

export const createOffer = async (offer: Offer): Promise<Offer> => {
  const response = await api.post(
    `${offersAdminApiPrefix}`,
    offerToUpsertRequest(offer),
  );

  return offerFromResponse(response.data?.data);
};

export const getOfferDescription = async (offer: Offer): Promise<string> => {
  const response = await api.post(
    `${offersAdminApiPrefix}/description`,
    offerToUpsertRequest(offer),
  );

  return response.data?.description ?? '';
};

export const getOffers = async (): Promise<Offer[]> => {
  const response = await api.get(offersAdminApiPrefix);

  return (response.data?.data ?? []).map((offer: any) =>
    offerFromResponse(offer),
  );
};

export const getOffer = async (id: number): Promise<Offer> => {
  const response = await api.get(`${offersAdminApiPrefix}/${id}`);

  return offerFromResponse(response.data?.data);
};

export const updateOffer = async (offer: Offer): Promise<Offer> => {
  const response = await api.put(
    `${offersAdminApiPrefix}/${offer.id}`,
    offerToUpsertRequest(offer),
  );

  return offerFromResponse(response.data?.data);
};

export const deleteOffer = async (id: number): Promise<void> =>
  api.delete(`${offersAdminApiPrefix}/${id}`);
